'use client'

import React from 'react'
import classNames from 'classnames'
import styles from './Typography.module.css'
import { BaseTypographyProps, ResponsiveProps, createCombinedStyles } from './typographyUtils'

export type HeadingVariant =
  | 'semi-bold-96'
  | 'semi-bold-72'
  | 'semi-bold-48'
  | 'semi-bold-36'
  | 'semi-bold-26'
  | 'semi-bold-22'
  | 'semi-bold-18'
  | 'semi-bold-15'

export interface HeadingProps extends BaseTypographyProps {
  variant?: HeadingVariant
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span'
  responsive?: ResponsiveProps
  uppercase?: boolean
}

export const Heading = ({
  children,
  variant = 'semi-bold-48',
  as: Component = 'h2',
  className = '',
  color,
  responsive,
  style = {},
  uppercase,
  ...props
}: HeadingProps) => {
  // Create combined styles using the utility function
  const combinedStyles = createCombinedStyles(style, color, responsive)

  // Add text-transform style if uppercase is explicitly set
  if (uppercase !== undefined) {
    combinedStyles.textTransform = uppercase ? 'uppercase' : 'none'
  }

  // Use classNames to combine classes
  const combinedClassNames = classNames(styles[variant], className)

  return (
    <Component className={combinedClassNames} style={combinedStyles} {...props}>
      {children}
    </Component>
  )
}

export default Heading
